import React, { FC } from 'react';
import omit from 'lodash-es/omit';

import { Box, Link, LinkProps } from '@rover/kibble/core';
import { useTheme } from '@rover/kibble/themes';

import LinkButton from './LinkButton';

type LinkButtonProps = React.ComponentProps<typeof LinkButton>;
export type NavBarItemProps = LinkProps | LinkButtonProps;

export const NavBarLink: FC<LinkProps> = ({ children, ...other }) => (
  <Link
    size="100"
    variant="navigation"
    underline={false}
    sx={{
      width: '100%',
      height: '100%',
    }}
    {...other}
  >
    {children}
  </Link>
);

const NavBarItem: FC<NavBarItemProps> = ({
  href,
  children,
  icon,
  iconAlignment,
  onClick,
  ...other
}) => {
  const theme = useTheme();
  const commonProps = { children: children || '', icon, iconAlignment, onClick };
  return (
    <Box
      {...omit(other, ['aria-expanded', 'aria-label'])}
      flex="1 1 fit-content"
      maxWidth="fit-content"
      minWidth="min-content"
      sx={{
        ':hover': {
          color: theme.textColor.navigation_hover.toString(),
          textDecoration: 'underline',
        },
        textWrap: 'balance',
      }}
    >
      {href ? (
        <NavBarLink
          href={href}
          aria-label={other['aria-label']}
          textAlign="left"
          {...commonProps}
        />
      ) : (
        <LinkButton
          aria-expanded={other['aria-expanded']}
          aria-label={other['aria-label']}
          textAlign="left"
          {...commonProps}
        />
      )}
    </Box>
  );
};

export default NavBarItem;
